import styled from "styled-components";
import { css, DefaultTheme, ThemedStyledProps } from "styled-components";

interface IStepButton {
	active: boolean;
}

interface CustomTheme extends DefaultTheme {
	pantone2726C: string;
}

export const ContainerStep = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	position: relative;
`;

export const ContainerStepComponent = styled.div`
	background-color: #fff;
	border-radius: 8px;
	margin-top: 20px;
`;

const stepButtonStyles = css`
	background-color: "#fff";
	border: 1px solid ${({ theme }) => theme.pantone2726C};
	border-radius: 50%;
	width: 50px;
	height: 50px;
	color: ${({ theme }) => theme.pantone2726C};
	z-index: 1;
	cursor: pointer;
`;

export const StepButton = styled.button<IStepButton>`
	${stepButtonStyles}

	${(props) =>
		props.active === true &&
		css`
			background-color: ${({ theme }: ThemedStyledProps<object, CustomTheme>) => theme.pantone2726C};
			color: #fff;
		`}
`;

export const StepCenterLine = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	width: 52%;
	height: 2px;
	background-color: ${({ theme }) => theme.pantone2726C};
	transform: translate(-50%);
`;

export const HeaderText = styled.p`
	color: #9f9f9f;
	font-size: 1rem;
	font-weight: bold;
`;

export const AreaSteps = styled.div`
	position: relative;
`;

export const ButtonHistory = styled.div`
	position: absolute;
	right: 0px;
	top: 50%;
	transform: translateY(-50%);

	@media (max-width: 768px) {
		top: -24px;

		button {
			padding: 5px;
			max-width: unset;
			min-width: 77px;
		}
	}
	@media (max-width: 330px) {
		position: relative;
		top: unset;
		right: unset;
		transform: unset;
		margin-top: 15px;
	}
`;

export const QuoteNumber = styled.h6`
	font-weight: bold;
	font-size: 0.95rem;
	position: absolute;
	left: 15px;
	top: 50%;
	transform: translateY(-50%);

	@media (max-width: 768px) {
		position: static;
	}
	@media (max-width: 330px) {
		position: static;
		top: unset;
		right: unset;
		transform: unset;
		margin-top: 15px;
	}
`;
